import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_DETAILS.id,
    mainReportId: ReportDefinitions.ORIGIN_IMPC_OPERATOR_PREDES_SENDER_MISMATCH_SUMMARY.id,
    requestParams: {
      impcFrom: rowInfo.row['originImpc.code'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: 'Origin IMPC',
      columns: [
        new TextColumn('Code', 'originImpc.code'),
        new TextColumn('Operator', 'originImpc.operator'),
      ],
    },
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Sender', 'predes.sender'),
        new TextColumn('Sending mailbox', 'predes.sendingMailbox'),
      ],
    },
    {
      Header: '',
      columns: [
        new NavigationColumn(new NonZeroNumberColumn('Despatches', 'despatches'), getTabNavigationProps),
      ],
    },
  ];
};
